window.onload = function() {
  var product_dropdown = document.querySelectorAll('.product-single__dropdown .dropdown-title');
  if (product_dropdown) {
    for (var i = 0; i < product_dropdown.length; i++) {
      product_dropdown[i].addEventListener('click', function(event) {
        var activeDd = document.querySelector('.dropdown-title.active');
        if(activeDd) activeDd.classList.remove('active');
        this.classList.add('active');
      });
    }
  }
  var product_slider = $('[data-new-slider]').flickity({
    cellAlign: 'center',
    contain: true,
    arrowShape:"M80 44H31.32l22.36-22.36L48 16l-32 32 32 32 5.64-5.64L31.32 52H80v-8z"
  });
  product_slider.on( 'change.flickity', function( event, index ) {
    $('[data-media-thumb]').removeClass('active');
    $('[data-media-thumb][data-slide="'+index+'"]').addClass('active');
  });
  $('[data-media-thumbnails]').on('click', '[data-media-thumb]', function() {
    let slide = $(this).data('slide');
    $('[data-media-thumb]').removeClass('active');
    $(this).addClass('active');
    product_slider.flickity( 'select', slide );
  });
  $('.product-form__chips').on('click', 'a', function(){
    let img = $('select[name="id"] option:selected').data('image');
    let slide = $('[data-image="'+img+'"]').data('slide');
    if(img) product_slider.flickity( 'select', slide );
  });

  if ($('.productCategory__video').length) {
    videoIframe();
    function videoIframe() {
      let iframe_width = $('.productCategory__video iframe').outerWidth();
      let iframe_height = iframe_width / 1.7777776;
      $('.productCategory__video iframe').css('height', iframe_height).css('opacity', 1);
    }
    $(window).on('resize', function() {
      videoIframe();
    })
  }
}